(function () {
  'use strict';

  var CM = 2.54;
  var KEY = 'kx_sg_unit';
  var MAX_GAP_IN = 2;
  var cache = {};
  var modal = null;
  var lastTrigger = null;

  function getStore() { try { return localStorage.getItem(KEY); } catch (e) { return null; } }
  function setStore(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }

  function parseNum(t) {
    t = String(t).trim();
    var m = t.match(/^(\d+)\s+(\d+)\s*\/\s*(\d+)$/);
    if (m) return +m[1] + (+m[2]) / (+m[3]);
    m = t.match(/^(\d+)\s*\/\s*(\d+)$/);
    if (m) return +m[1] / +m[2];
    var n = parseFloat(t.replace(',', '.'));
    return isNaN(n) ? null : n;
  }

  function parseRange(s) {
    var parts = String(s).split(/\s*[\u2013\u2014-]\s*/)
      .map(parseNum)
      .filter(function (n) { return n !== null; });
    if (!parts.length) return null;
    return [parts[0], parts[parts.length - 1]];
  }

  function fmt(n) {
    var r = Math.round(n * 10) / 10;
    return r % 1 === 0 ? String(r) : r.toFixed(1);
  }

  function toCm(raw) {
    var r = parseRange(raw);
    if (!r) return raw;
    return r[0] === r[1] ? fmt(r[0] * CM) : fmt(r[0] * CM) + '\u2013' + fmt(r[1] * CM);
  }

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  function ensureFont(root) {
    if (!root.getAttribute('data-font')) return;
    if (document.querySelector('link[href*="Bodoni+Moda"]')) return;
    var l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = 'https://fonts.googleapis.com/css2?family=Bodoni+Moda:ital,opsz,wght@0,6..96,400;0,6..96,500;1,6..96,400&display=swap';
    document.head.appendChild(l);
  }

  function getRows(root) {
    var table = root.querySelector('[data-kx-body]');
    if (!table) return [];
    return Array.prototype.map.call(table.querySelectorAll('tbody tr'), function (tr) {
      var o = { el: tr, size: tr.getAttribute('data-size') || '', m: {} };
      each(tr.querySelectorAll('[data-m]'), function (td) {
        var r = parseRange(td.getAttribute('data-in'));
        if (r) o.m[td.getAttribute('data-m')] = r;
      });
      return o;
    });
  }

  function bestIndex(rows, key, val) {
    var best = -1, bd = Infinity;
    rows.forEach(function (r, i) {
      var rg = r.m[key];
      if (!rg) return;
      var d = val < rg[0] ? rg[0] - val : (val > rg[1] ? val - rg[1] : 0);
      if (d < bd || (d === bd && i > best)) { bd = d; best = i; }
    });
    return { i: best, d: bd };
  }

  function label(key) { return key.charAt(0).toUpperCase() + key.slice(1); }

  function init(root, opts) {
    if (!root || root.getAttribute('data-kx-init')) return;
    opts = opts || {};
    root.setAttribute('data-kx-init', '1');
    root.classList.add('kxsg--js');
    ensureFont(root);

    var unit = getStore() || root.getAttribute('data-default-unit') || 'in';
    if (unit !== 'in' && unit !== 'cm') unit = 'in';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[role="tabpanel"]'));

    function showTab(key, focus) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-tab') === key;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus();
      });
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== key; });
    }

    if (tabs.length) {
      var wanted = opts.tab || (!opts.modal ? location.hash.replace('#', '') : '');
      var keys = tabs.map(function (t) { return t.getAttribute('data-tab'); });
      showTab(keys.indexOf(wanted) > -1 ? wanted : keys[0]);

      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { showTab(t.getAttribute('data-tab')); });
        t.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowRight') n = (i + 1) % tabs.length;
          else if (e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
          else if (e.key === 'Home') n = 0;
          else if (e.key === 'End') n = tabs.length - 1;
          if (n !== null) { e.preventDefault(); showTab(tabs[n].getAttribute('data-tab'), true); }
        });
      });
    }

    function setUnit(u) {
      unit = u;
      root.setAttribute('data-unit', u);
      each(root.querySelectorAll('[data-kx-unit]'), function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-kx-unit') === u ? 'true' : 'false');
      });
      each(root.querySelectorAll('td[data-in]'), function (td) {
        var raw = td.getAttribute('data-in');
        if (!raw) return;
        td.textContent = u === 'in' ? td.getAttribute('data-disp') : toCm(raw);
      });
      each(root.querySelectorAll('[data-kx-unit-label]'), function (el) { el.textContent = u; });
      each(root.querySelectorAll('[data-kx-input]'), function (inp) {
        inp.placeholder = u === 'in' ? 'e.g. 28' : 'e.g. 71';
      });
    }
    each(root.querySelectorAll('[data-kx-unit]'), function (b) {
      b.addEventListener('click', function () {
        setUnit(b.getAttribute('data-kx-unit'));
        setStore(unit);
      });
    });
    setUnit(unit);

    var pr = root.querySelector('[data-kx-print]');
    if (pr) pr.addEventListener('click', function () { window.print(); });

    var form = root.querySelector('[data-kx-finder]');
    if (form) {
      var out = form.querySelector('[data-kx-result]');

      var clearMatch = function () {
        getRows(root).forEach(function (r) { r.el.classList.remove('is-match'); });
      };

      var box = function (cls) {
        out.textContent = '';
        var d = document.createElement('div');
        d.className = 'kxsg__result-box' + (cls ? ' ' + cls : '');
        out.appendChild(d);
        return d;
      };

      var line = function (parent, cls, text) {
        var p = document.createElement('p');
        p.className = cls;
        p.textContent = text;
        parent.appendChild(p);
        return p;
      };

      var run = function () {
        var vals = {}, any = false, bad = false;
        each(form.querySelectorAll('[data-kx-input]'), function (inp) {
          var raw = inp.value.trim();
          if (!raw) return;
          var n = parseNum(raw);
          if (n === null || n <= 0) { bad = true; return; }
          var inches = unit === 'cm' ? n / CM : n;
          if (inches < 15 || inches > 90) { bad = true; return; }
          vals[inp.getAttribute('data-kx-input')] = inches;
          any = true;
        });

        clearMatch();

        if (bad || !any) {
          var e = box('is-error');
          line(e, 'kxsg__result-detail',
            bad
              ? 'Check your numbers. Enter measurements in ' + (unit === 'cm' ? 'centimeters' : 'inches') + ', for example ' + (unit === 'cm' ? '71' : '28') + '.'
              : 'Enter at least one measurement to see a suggestion.');
          return;
        }

        var rows = getRows(root);
        var picks = [], far = false, gap = false, idxs = [];
        Object.keys(vals).forEach(function (k) {
          var b = bestIndex(rows, k, vals[k]);
          if (b.i < 0) return;
          if (b.d > MAX_GAP_IN) far = true;
          if (b.d > 0) gap = true;
          idxs.push(b.i);
          picks.push(label(k) + ': ' + rows[b.i].size);
        });

        if (!idxs.length) return;

        if (far) {
          var f = box('is-error');
          line(f, 'kxsg__result-detail',
            'One of your measurements sits outside our size range. Contact us and we will help you find the closest fit.');
          return;
        }

        var idx = Math.max.apply(null, idxs);
        var differ = idxs.some(function (i) { return i !== idx; });
        var ok = box('');
        var p = document.createElement('p');
        p.className = 'kxsg__result-size';
        p.appendChild(document.createTextNode('We suggest size '));
        var s = document.createElement('strong');
        s.textContent = rows[idx].size;
        p.appendChild(s);
        ok.appendChild(p);

        if (picks.length > 1) line(ok, 'kxsg__result-detail', picks.join('  \u00b7  '));
        if (differ) line(ok, 'kxsg__result-detail', 'Your measurements fall in different sizes, so we chose the larger one for comfort.');
        if (gap) line(ok, 'kxsg__result-detail', 'A measurement sits between two sizes. For a closer fit, try the smaller size in a stretch fabric.');
        line(ok, 'kxsg__result-detail', 'Always check the product page for fabric stretch and fit notes.');

        rows[idx].el.classList.add('is-match');

        if (tabs.length && root.querySelector('[data-panel="body"]')) {
          var link = document.createElement('button');
          link.type = 'button';
          link.className = 'kxsg__result-link';
          link.textContent = 'See this size in the chart';
          link.addEventListener('click', function () {
            showTab('body');
            rows[idx].el.scrollIntoView({ block: 'center', behavior: 'smooth' });
          });
          ok.appendChild(link);
        }
      };

      form.addEventListener('submit', function (e) { e.preventDefault(); run(); });
      form.addEventListener('reset', function () { out.textContent = ''; clearMatch(); });
    }
  }

  function initAll(scope) {
    each((scope || document).querySelectorAll('[data-kx-sg]'), function (r) { init(r); });
  }

  function load(src) {
    if (cache[src]) return cache[src];
    cache[src] = fetch(src, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var root = doc.querySelector('[data-kx-sg]');
        if (!root) throw new Error('Size guide not found on page');
        each(root.querySelectorAll('script'), function (s) { s.parentNode.removeChild(s); });
        return root.outerHTML;
      })
      .catch(function (err) { delete cache[src]; throw err; });
    return cache[src];
  }

  function ensureModal() {
    if (modal) return modal;
    var d = document.createElement('dialog');
    d.className = 'kxsg-dialog';
    d.setAttribute('aria-label', 'Size guide');
    d.innerHTML =
      '<button type="button" class="kxsg-dialog__close" aria-label="Close size guide">&times;</button>' +
      '<div data-kx-dialog-body></div>';
    document.body.appendChild(d);
    d.querySelector('.kxsg-dialog__close').addEventListener('click', function () { d.close(); });
    d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
    d.addEventListener('close', function () {
      document.documentElement.classList.remove('kxsg-lock');
      if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
    });
    modal = d;
    return d;
  }

  function openModal(trigger) {
    var src = trigger.getAttribute('href') || trigger.getAttribute('data-src') || '/pages/size-charts';
    var tab = trigger.getAttribute('data-tab') || '';
    var d = ensureModal();
    var body = d.querySelector('[data-kx-dialog-body]');
    lastTrigger = trigger;

    body.innerHTML = '<p class="kxsg-dialog__loading">Loading size guide\u2026</p>';
    document.documentElement.classList.add('kxsg-lock');
    if (!d.open) d.showModal();

    load(src).then(function (html) {
      body.innerHTML = html;
      var root = body.querySelector('[data-kx-sg]');
      d.style.cssText = root.style.cssText;
      init(root, { tab: tab, modal: true });
    }).catch(function () {
      body.textContent = '';
      var p = document.createElement('p');
      p.className = 'kxsg-dialog__loading';
      p.appendChild(document.createTextNode('We could not load the size guide here. '));
      var a = document.createElement('a');
      a.href = src;
      a.textContent = 'Open the full size guide page';
      p.appendChild(a);
      body.appendChild(p);
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-kx-sg-open]');
    if (!t || !window.HTMLDialogElement) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    e.preventDefault();
    openModal(t);
  });

  function prefetch(e) {
    var t = e.target.closest && e.target.closest('[data-kx-sg-open]');
    if (!t) return;
    var src = t.getAttribute('href') || t.getAttribute('data-src');
    if (src) load(src).catch(function () {});
  }
  document.addEventListener('pointerover', prefetch, { passive: true });
  document.addEventListener('focusin', prefetch);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();